module.exports = __webpack_public_path__ + "images/img-2ks79Vw.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/ranks/3.jpg
// module id = 2030
// module chunks = 0